// extracted by mini-css-extract-plugin
export var noSpinners = "_oi-6";
export var percentageInput = "_oi-7";
export var variantColor1 = "_oi-0";
export var variantColor2 = "_oi-1";
export var variantColor3 = "_oi-2";
export var variantColor4 = "_oi-3";
export var variantColor5 = "_oi-4";
export var variantColor6 = "_oi-5";